import { userConstants } from "../_constants";

let user = JSON.parse(localStorage.getItem("user"));
let initialState = user ? { loggedIn: true, user } : {};

export function authentication(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        loggingIn: true,
        user: action.user,
      };
    case userConstants.LOGIN_SUCCESS:
    case userConstants.AUTH_SUCCESS:
      return {
        loggedIn: true,
        user: action.user,
      };
    case userConstants.LOGIN_FAILURE:
    case userConstants.LOGOUT:
    case userConstants.AUTH_ERROR:
      return {};
    case userConstants.USER_UPDATE:
      return {
        loggedIn: true,
        user: action.user,
      };
    default:
      return state;
  }
}
